import { Component } from '@angular/core';
import { AuthService } from '../../auth.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { EmailValidator } from '../../validators/email';
import { DadosService } from '../../services/dados.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';



@Component({
  selector: 'app-capa',
  templateUrl: './pre-vestibular.component.html',
  styleUrls: ['./pre-vestibular.component.css']
})
export class PreVestibularComponent {

  email;
  senha;
  mensagemErro;
  emailValido = false;
  showLoading = false;
  modalOpened: NgbModalRef;
  modalResetSenha: NgbModalRef;
  modalCriarNovo: NgbModalRef;

  usuario;
  senhaescolaiterativa;
  emailValidoNovo = false;
  emailnovo;
  showLoadingBusca = false;
  showLoadingcriarusuario = false;

  dadosrecebidos = {};
  dadosselecionados = {};
  alunosregistrados: Observable<any[]>;
  arraycidades = [];
  cidadeselecionada = null;
  imagemaluno = null;

  constructor(public authService: AuthService,
    public router: Router,
    public modalService: NgbModal, private dadosService: DadosService) {
    this.email = "";
    this.senha = "";
  }

  login() {
    this.showLoading = true;
    this.mensagemErro = undefined;

    this.authService.loginPorEmail(this.email.trim(), this.senha)
      .then(authData => {

        this.dadosService.getByField('uid', authData.user.uid).valueChanges().subscribe(us => {
          if (us[0]["isAdm"] == true) {
            this.router.navigate(['/dashboardadm']);
          } else {
            if (us[0]["isVendedor"] == false) {
              this.router.navigate(['/dashboard']);
            } else {
              this.router.navigate(['/dashboard']);
            }

          }
        })

      }, error => {
        this.mensagemErro = 'Login ou senha incorretos, tente novamente.';
        this.showLoading = false;
      });

  }

  // modal code
  openModal(content) {
    this.mensagemErro = undefined;
    this.emailValido = undefined;
    this.email = "";
    this.emailnovo = "";
    this.modalOpened = this.modalService.open(content, { size: 'lg', centered: true });
  }

  modalprimeiroacesso(contentprimeiroacesso) {
    this.modalResetSenha = this.modalService.open(contentprimeiroacesso, { size: 'lg', centered: true });
  }
  
  modalacessorestrito(contentacessorestrito) {
    this.modalResetSenha = this.modalService.open(contentacessorestrito, { size: 'lg', centered: true });
  }

  atendimentoOnline(contentatendimentoonline) {
    this.modalResetSenha = this.modalService.open(contentatendimentoonline, { size: 'lg', centered: true });
  }
   	
  esqueceuSenha(content) {
    this.validarEmail();
    this.modalResetSenha = this.modalService.open(content, { size: 'sm', centered: true });
  }


  enviarEmailEsqueceuSenha() {
    if (this.emailValido) {
      this.authService.enviaRecuperacaoSenha(this.email);
      this.modalResetSenha.close();
      alert('Email de reset de senha foi enviado. Verifique seu email.');
    } else {
      alert('Por favor, informe um email válido.');
    }

  }

  validarEmail() {
    this.emailValidoNovo = EmailValidator.isValid(this.email);
  }


  validarEmailNovo(email) {
    this.emailValidoNovo = EmailValidator.isValid(email);
  }




  async buscarUsuario(content) {
    this.showLoadingBusca = true;
    let retorno = await this.dadosService.buscarUsuarioBaseAntiga(this.usuario);

    this.dadosrecebidos = JSON.parse(retorno["_body"]);

    let pares = []

    for (var p in this.dadosrecebidos) {
      pares.push([p, this.dadosrecebidos[p]]);
    }
    this.dadosrecebidos = pares[0][1];
    if (this.dadosrecebidos !== "erro") {

      this.emailValidoNovo = undefined;

      this.emailnovo = this.dadosrecebidos["e-mail"] != "" ? this.dadosrecebidos["e-mail"] : undefined;
      if (this.emailnovo !== undefined) {
        this.validarEmailNovo(this.emailnovo);
      }

      this.dadosService.getByField("usuario", this.usuario).valueChanges().subscribe(busca => {
        if (busca[0] !== undefined) {
          alert("Já foi criado um primeiro acesso para esse usuário.\n Acesse com o e-mail cadastrado e, caso precise, recupere sua senha.");
          this.showLoadingBusca = false;
          return;
        }
      })

      this.modalCriarNovo = this.modalService.open(content, { size: 'lg', centered: true });
    } else {
      alert("Dados de usuário não encontrados, por favor verifique!");

    }
    this.showLoadingBusca = false;
  }


  async buscarUsuarioVarios(content) {
    this.showLoadingBusca = true;
    let retorno = await this.dadosService.buscarUsuarioBaseAntigaVarios(this.usuario);

    this.dadosrecebidos = JSON.parse(retorno["_body"]);
    //console.log(this.dadosrecebidos);
    let pares = []


    for (var p in this.dadosrecebidos) {
      pares.push([p, this.dadosrecebidos[p]]);
    }
    this.dadosrecebidos = pares;

    if (this.dadosrecebidos[0][1] !== "erro") {
      this.modalCriarNovo = this.modalService.open(content, { size: 'lg', centered: true });
    } else {
      alert("Dados de usuário não encontrados, por favor verifique!");
    }

    this.showLoadingBusca = false;
  }


  selecionaContratante(item) {
    this.dadosselecionados = item;
    this.emailnovo = this.dadosselecionados["e-mail"] != "" ? this.dadosselecionados["e-mail"] : undefined;
    if (this.emailnovo !== undefined) {
      this.validarEmailNovo(this.emailnovo);
    }

  }


  criarUsuarioNovoDadosAntigos() {
    this.showLoadingcriarusuario = true;
    //criar usuário para acesso a plataforma
    if (this.emailnovo !== undefined) {
      this.authService.criarUsuario(this.emailnovo, this.senhaescolaiterativa).then(obj => {
        if (obj.code != "auth/email-already-in-use") {
          let selecionado = {};
          selecionado["uid"] = obj.user.uid;
          selecionado["isAdm"] = false;
          selecionado["isVendedor"] = false;
          selecionado["UltimaLiberacaoEm"] = new Date().getTime();
          selecionado["liberado"] = true;
          selecionado["codigoinscricao"] = this.senhaescolaiterativa;

          //dados base antiga
          selecionado["nome"] = this.dadosselecionados["nome_contratante"] !== undefined ? this.dadosselecionados["nome_contratante"] : "";
          selecionado["nomealuno"] = this.dadosselecionados["nome_aluno"] !== undefined ? this.dadosselecionados["nome_aluno"] : "";
          selecionado["cep"] = this.dadosselecionados["cep"] !== undefined ? this.dadosselecionados["cep"] : "";
          selecionado["cidade"] = this.dadosselecionados["cidade"] !== undefined ? this.dadosselecionados["cidade"] : "";
          selecionado["email"] = this.dadosselecionados["e-mail"] !== undefined ? this.dadosselecionados["e-mail"] : "";
          selecionado["endereco"] = this.dadosselecionados["endereco"] !== undefined ? this.dadosselecionados["endereco"] : "";
          selecionado["datacadastro"] = this.dadosselecionados["data_cadastro"] !== undefined ? this.dadosselecionados["data_cadastro"] : "";
          selecionado["data_expiracao"] = this.dadosselecionados["data_expiracao"] !== undefined ? this.dadosselecionados["data_expiracao"] : "";
          selecionado["datanascimento"] = this.dadosselecionados["nascimento"] !== undefined ? this.dadosselecionados["nascimento"] : "";
          selecionado["numero"] = this.dadosselecionados["numero"] !== undefined ? this.dadosselecionados["numero"] : "";
          selecionado["telefone"] = this.dadosselecionados["telefone"] !== undefined ? this.dadosselecionados["telefone"] : "";
          selecionado["uf"] = this.dadosselecionados["uf"] !== undefined ? this.dadosselecionados["uf"] : "";
          selecionado["usuario"] = this.dadosselecionados["usuario"] !== undefined ? this.dadosselecionados["usuario"] : "";
          if (selecionado["data_expiracao"] != "") {
            let datasplit = selecionado["data_expiracao"].split("/");
            selecionado["vigencia"] = new Date(datasplit[2], datasplit[1], datasplit[0]).getTime();
          } else {
            selecionado["vigencia"] = new Date().getTime();
          }
          this.dadosService.add(selecionado);
          alert("Usuário salvo, use seu e-mail e senha para os próximos logins. Bons estudos!");
          this.modalCriarNovo.dismiss();
          this.showLoadingcriarusuario = false;
          this.router.navigate(['/dashboard']);

        } else {
          alert("E-mail já em uso, por favor, informe outro e-mail.");
          this.showLoadingcriarusuario = false;
        }
      });
    }

  }

  abreAlunosEstado(estado){
    this.cidadeselecionada = null;
    this.arraycidades = [];
    this.alunosregistrados = this.dadosService.getByTripleFieldOrdener("isAdm", false, "isVendedor", false, "uf", estado, "nome").snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data();
        if(this.arraycidades.indexOf(data["cidade"].trim())<0){
          this.arraycidades.push(data["cidade"].trim());
          this.arraycidades.sort();
        }
        const id = a.payload.doc.id;
        return { id, ...data as any };
      })));
    
  }

  atribuiCidade(cidade){
    this.cidadeselecionada = cidade;
  }

  carregarfoto(aluno){

    console.log(aluno.arquivo);
    if((aluno.arquivo === null) || (aluno.arquivo === undefined)){
      return "../../../assets/img/logo-grupo-cultural-rodape.png";
    } else {
      return aluno.arquivo;
    }
  }

}
